(() => {
	const searchParams = new URLSearchParams(window.location.search);

	// If UTM parameters already exist, don't touch them
	if (searchParams.has("utm_source") || searchParams.has("utm_medium")) {
		return;
	}

	const referrer = document.referrer;

	// No referrer? Do nothing (direct traffic)
	if (!referrer) {
		return;
	}

	// Check if referrer is from the same site (internal navigation)
	try {
		const referrerUrl = new URL(referrer);
		if (referrerUrl.hostname === window.location.hostname) {
			return; // Internal navigation - don't set anything
		}
	} catch {
		return; // Invalid referrer - don't set anything
	}

	// At this point we know it's external traffic
	// Check if it's a search engine to set the correct source and medium
	const SEARCH_ENGINES = [
		{ name: "aol", pattern: "search.aol." },
		{ name: "ask", pattern: "ask." },
		{ name: "baidu", pattern: "baidu." },
		{ name: "bing", pattern: "bing." },
		{ name: "brave", pattern: "search.brave." },
		{ name: "duckduckgo", pattern: "duckduckgo." },
		{ name: "ecosia", pattern: "ecosia.org" },
		{ name: "google", pattern: "google." },
		{ name: "kagi", pattern: "kagi.com" },
		{ name: "naver", pattern: "search.naver." },
		{ name: "qwant", pattern: "qwant." },
		{ name: "seznam", pattern: "search.seznam.cz" },
		{ name: "startpage", pattern: "startpage." },
		{ name: "swisscows", pattern: "swisscows." },
		{ name: "yahoo", pattern: "yahoo." },
		{ name: "yandex", pattern: "yandex." },
	];

	let source;
	let medium;

	// Check if it's a known search engine
	for (const engine of SEARCH_ENGINES) {
		if (referrer.includes(engine.pattern)) {
			source = engine.name;
			medium = "organic";
			break;
		}
	}

	// If it's not a known search engine, use the hostname as source
	if (!source) {
		const referrerUrl = new URL(referrer);
		source = referrerUrl.hostname;
	}

	// Set the UTM parameters
	searchParams.set("utm_source", source);
	if (medium) searchParams.set("utm_medium", medium);

	// Update URL without reload using History API
	const newUrl =
		window.location.pathname +
		"?" +
		searchParams.toString() +
		window.location.hash;
	window.history.replaceState(null, "", newUrl);
})();
